import { Component, OnInit, DoCheck, ViewChild, Input, Output, ElementRef, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
import { MatPaginator, MatSort } from '@angular/material';
import { saveAs as importedSaveAs } from "file-saver";

import { environment } from './../../../../environments/environment';

import { AppComponent } from './../../../app.component';

import { Book } from '../../../models/Book';
import { BookService } from './../../../services/book.service';
import { SharedService } from './../../../services/shared.service';
import { MatTableCustomDataSource, MatTableCustomApi, MatTableCustomDao } from './../../../helpers/mat-table-datasource';

import * as moment from 'moment';

import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-book-search',
  templateUrl: './book-search.component.html',
  styleUrls: ['./book-search.component.css'],
  providers: [BookService],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class BookSearchComponent implements OnInit {
  displayedColumns = ['ean13', 'autoriabbreviatoedb', 'titoloEDB', 'dtpubblicazione', 'collana'];
  bookDatabase: MatTableCustomDao<Book> | null;
  dataSource: MatTableCustomDataSource<Book, MatTableCustomApi<Book>>;
  printing: boolean = false;
  @Input() nested: boolean = false;
  @Output() notify: EventEmitter<Book> = new EventEmitter<Book>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('qfilter') qfilter: ElementRef;

  // filter: EventEmitter<String> = new EventEmitter<String>();

  wmodel: Book = new Book();

  downloadingCSVExportRL: boolean = false;

  chipselectable: boolean = true;
  filter: EventEmitter<any> = new EventEmitter<any>();
  filterModel: any = {};
  activeFilter: string;
  filters: any[] = [];

  isExpansionDetailRow = (i, row: any) => row.hasOwnProperty('detailRow');

  getTitle(): string {
    return "libri";
  }

  _collana(onix3: any) {
    let flatBook = this.bookService.fromMongo(onix3);
    return flatBook.collana ? flatBook.collana.codice : undefined;
  }

  constructor(
    private router: Router,
    private bookService: BookService,
    private sharedService: SharedService,
    public parent: AppComponent) {

    this.sharedService.sharedEmitter.subscribe((o) => {
      console.log('Emitted data', o);

      // ============ AGGIORNAMENTO ROW MatTable ============
      if (o) {
        const _data = this.dataSource.data;
        let wndx = this.dataSource.data.findIndex(c => c.ean13 == o.ean13);
        console.log('MATCH', wndx);
        if (wndx != -1) {
          _data[wndx] = o;
          console.log('MATCH object', _data[wndx]);
        }

        // ============ AGGIORNAMENTO ROW MatTable EXPANDED ROW  ============
        let wndxdet = this.dataSource.data.findIndex(c => (c.hasOwnProperty('element') && c['element'].ean13 == o.ean13));
        console.log('MATCH DETAIL', wndxdet);
        if (wndxdet != -1) {
          console.log('MATCH DETAIL object', _data[wndxdet]);
          _data[wndxdet]['element'] = o;
        }
        this.dataSource.data = _data;
      }
      // ============ AGGIORNAMENTO ROW MatTable ============
    })
  }

  search() {
    let wa = []
    this.filters.forEach(o => {
      wa.push(o.q)
    })
    this.filter.emit(wa);
  }

  edit(_ean13) {
    this.router.navigate(['/book/' + _ean13]);
  }

  servizioStampa(_ean13) {
    this.router.navigate(['/servizio-stampa/' + _ean13]);
  }

  recensioni(_ean13) {
    this.router.navigate(['/recensioni/' + _ean13]);
  }

  extra(_ean13) {
    this.router.navigate(['/extra/' + _ean13]);
  }

  clonaLibro(_ean13) {
    this.router.navigate(['/clone-book/' + _ean13]);
  }

  add() {
    this.router.navigate(['/book']);
  }

  choose() {
    console.log('chooooose', this.bookService.selected)
    this.bookService.getBook(this.bookService.selected).subscribe(result => {
      console.log(result)
      if (result.success && result.book) {
        this.notify.emit(new Book(result.book));
      }
    })
  }

  download() {
    this.parent.addToast('', 'estrazione in corso', ((wid) => {
      setTimeout(() => {
        let wa = []
        this.filters.forEach(o => {
          wa.push(o.q)
        })
        this.bookService.downloadFile(wa).subscribe(data => {
          let file = new Blob([data], { type: 'application/vnd.ms-excel' });
          importedSaveAs(file, 'elzeviro' + (moment().format('[-]YYYYMMDD[-]hhmmss')) + '.xlsx');
          this.parent.clearToast(wid);
          this.parent.operSnackBar(true, 'operazione completata');
        })
      }, 1000);
    }))
  }

  downloadFullXlxs() {
    this.parent.addToast('', 'estrazione in corso', ((wid) => {
      setTimeout(() => {
        this.bookService.downloadFullXlxs().subscribe(data => {
          let file = new Blob([data], { type: 'application/vnd.ms-excel' });
          importedSaveAs(file, 'elzeviro-full' + (moment().format('[-]YYYYMMDD[-]hhmmss')) + '.xlsx');
          this.parent.clearToast(wid);
          this.parent.operSnackBar(true, 'operazione completata');
        })
      }, 1000);
    }))
  }

  downloadCSVExportRL() {
    this.downloadingCSVExportRL = true;
    this.parent.addToast('', 'creazione CSV in corso', ((wid) => {
      setTimeout(() => {
        this.bookService.createCSVExportRL().subscribe(data => {
          // let file = new Blob([data], { type: 'application/csv' });
          // importedSaveAs(file, 'exportRL' + (moment().format('[-]YYYYMMDD[-]hhmmss')) + '.csv');

          let file = new Blob([data], { type: 'application/zip' });
          importedSaveAs(file, 'exportRL-' + environment.publisher + (moment().format('[-]YYYYMMDD[-]hhmmss')) + '.zip');

          this.parent.clearToast(wid);
          this.parent.operSnackBar(true, 'operazione completata');
          this.downloadingCSVExportRL = false;
        })
      }, 1000);
    }))
  }

  addFilter(e) {
    console.log(e)
    if (e) {
      this.filters.push(e);
      this.activeFilter = '';
      this.search();
    }
  }

  removeFilter(f: any): void {
    let index = this.filters.indexOf(f);
    if (index >= 0) {
      this.filters.splice(index, 1);
      this.search();
    }
  }

  openFilter(f: any): void {
    console.log('******reopenFilter', f)
    this.filterModel[f.t.k] = f.o ? f.o : f.q.value;
    this.activeFilter = f.t.k;
    this.removeFilter(f);
  }

  shownFilter(s: string) {
    return this.filters.some(item => item.t.k === s);
  }

  highlight(_ean13) {
    this.bookService.selected = _ean13;
  }

  ngOnInit() {
    this.bookDatabase = new MatTableCustomDao(this.bookService);
    this.dataSource = new MatTableCustomDataSource(
      this.bookDatabase!,
      this.paginator,
      this.sort,
      this.filter,
      true);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/book/book-search/book-search.component.ts